import { isUseGesture } from "./utils";

const points_images_to_preload = [
  "/img/palm/right-hand-mask.svg",
  "/svg/dot.svg",
  "/img/icon/loading.svg",
];

const IMAGES_TO_PRELOAD = isUseGesture()
  ? [
      "/img/gesture/pointing.svg",
      "/img/gesture/scissors.svg",
      "/img/gesture/three.svg",
      "/img/gesture/four.svg",
      "/img/gesture/fist.svg",
      "/img/gesture/thumbsUp.svg",
      "/img/gesture/l.svg",
      "/img/gesture/paper.svg",
      "/img/gesture/circle.svg",
      "/img/gesture/back.svg",
      "/img/gesture/shaka.svg",
      "/img/gesture/doubleL.svg",
      "/img/palm/right-hand-mask.svg",
      "/img/icon/loading.svg",
    ]
  : points_images_to_preload;

export const preloadImages = async (urls: string[]) => {
  return Promise.allSettled(
    urls.map(
      (url) =>
        new Promise((resolve, reject) => {
          // Strategy: Use fetch API first to preload into HTTP cache with high priority
          // Then verify with Image object to ensure it's actually loadable
          // This approach ensures better cache utilization and priority handling

          // Step 1: Preload via fetch with high priority (better for navigation scenarios)
          fetch(url, {
            method: "GET",
            // Use 'default' cache mode to respect browser cache headers
            // This ensures the image is cached properly for subsequent navigations
            cache: "default",
            // Set high priority hint (if supported by browser)
            priority: "high" as RequestPriority,
          })
            .then((response) => {
              if (!response.ok) {
                throw new Error(`HTTP ${response.status}`);
              }
              // Consume the response to ensure it's cached
              return response.blob();
            })
            .then(() => {
              // Step 2: Verify with Image object to ensure it's actually loadable
              const img = new Image();
              // Set fetchPriority if supported (Chrome 101+)
              // Use type assertion to set fetchPriority property
              if ("fetchPriority" in img) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (img as any).fetchPriority = "high";
              }

              img.onload = () => resolve(url);
              img.onerror = () =>
                reject(new Error(`Image load failed: ${url}`));
              img.src = url;
            })
            .catch((error) => {
              // Fallback: If fetch fails, try direct Image loading
              const img = new Image();
              if ("fetchPriority" in img) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (img as any).fetchPriority = "high";
              }
              img.onload = () => resolve(url);
              img.onerror = () => reject(error);
              img.src = url;
            });
        })
    )
  ).then((results) => {
    // Log failed images but don't throw error
    const failed = results
      .map((result, index) => ({ result, url: urls[index] }))
      .filter(({ result }) => result.status === "rejected");
    if (failed.length > 0) {
      console.warn(
        "[Preload] Some images failed to load:",
        failed.map(({ url }) => url)
      );
      return false;
    }
    return true;
  });
};

export function preloadScanPageImages() {
  return preloadImages(IMAGES_TO_PRELOAD);
}
